require('../../../src/stylus/components/_grid.styl');

import Grid from './grid';

export default Grid('layout');


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VGrid/VLayout.js
// module id = ydBJ
// module chunks = 0